export const NEWS_AI_GENERIC_ERROR_MESSAGE = 'An error occurred while generating AI response. Please try again or contact support.';
